// extracted by mini-css-extract-plugin
export var backdropBlur = "_71-0";
export var body = "_71-5";
export var bodyScroll = "_71-6";
export var columnFooter = "_71-7";
export var columnFooterFlush = "_71-8";
export var contentColumn = "_71-4";
export var frame = "_71-3";
export var heroContent = "_71-c";
export var heroOverlay = "_71-b";
export var image = "_71-a";
export var imageWrapper = "_71-9";
export var modal = "_71-1";
export var modalMain = "_71-2";
export var productHeader = "_71-d";
export var productHeaderIcon = "_71-e";
export var productHeaderName = "_71-f";
export var progressIndicator = "_71-g";